"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadReader = exports.FileUploadReader = exports.UniversalFileUploadReader = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
class UniversalFileUploadReader {
    constructor(file, field) {
        this.file = file;
        this.buffer = null;
        this.isFailed = false;
        this.isLoading = true;
        this.name = file.name;
        this.type = file.type;
        this.size = file.size;
        this.field = field;
        this.fileReader = new FileReader();
        this.fileReader.onerror = this.onFileError;
        this.fileReader.onload = this.onFileLoad;
        this.fileReader.readAsArrayBuffer(file);
    }
    onFileError() {
        var _a;
        (_a = this.fileReader) === null || _a === void 0 ? void 0 : _a.abort();
        this.isFailed = true;
        this.isLoading = false;
    }
    onFileLoad() {
        var _a;
        this.isFailed = false;
        this.isLoading = false;
        if (((_a = this.fileReader) === null || _a === void 0 ? void 0 : _a.result) && this.fileReader.result instanceof ArrayBuffer) {
            this.buffer = new Uint8Array(this.fileReader.result);
        }
        this.fileReader = null;
    }
}
exports.UniversalFileUploadReader = UniversalFileUploadReader;
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "buffer", void 0);
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "isFailed", void 0);
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "isLoading", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], UniversalFileUploadReader.prototype, "onFileError", null);
tslib_1.__decorate([
    mobx_1.action.bound
], UniversalFileUploadReader.prototype, "onFileLoad", null);
class FileUploadReader extends UniversalFileUploadReader {
}
exports.FileUploadReader = FileUploadReader;
class ImageUploadReader extends UniversalFileUploadReader {
}
exports.ImageUploadReader = ImageUploadReader;
//# sourceMappingURL=upload.reader.js.map